export const FETCH_NOTIFICATION = 'pages/notification/FETCH_NOTIFICATION';
export const NOTIFICATION_COUNT = 'pages/notification/NOTIFICATION_COUNT';
